/**
 * Optimizely Feature Flag Keys
 *
 * Centralized constants for all Optimizely feature flags and experiments.
 * Update this file when adding new flags in the Optimizely dashboard.
 */

export const OPTIMIZELY_FLAGS = {
	FACILITY_PAGE_TESTING: 'ssdc_facility_redesign_ab_testing_26Q1',
	CLP_TESTING: 'ssdc_clp_ab_testing_26Q1',
};

export default OPTIMIZELY_FLAGS;
